define('views/modules/template/edit/template',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/events/template-events',
    // views
    'src/views/responsive-view',
    'views/modules/template/edit/template-content',
    'views/parts/header/default-header',
    // templates
    'text!templates/modules/template/edit/template.html'
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    TemplateEvents,
    // views
    VResponsive,
    VTemplateContent,
    VDefaultHeader,
    // templates
    TTemplate
) {

    var VTemplate = VResponsive.extend({
        template: TTemplate,

        regions: {
            root: '.template-module',
            content: '.template-content',
            header: '.template-header'
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group,
                url: opt.url,
                role: opt.role,
                profile: opt.profile
            });

            var model = this.model,
                view = this.view = {
                    content: new VTemplateContent({
                        model: model,
                        collection: this.collection,
                        group: this.group,
                        role: this.role,
                        profile: this.profile
                    }),
                    header: new VDefaultHeader({
                        title: 'Edit template',
                    })
                };

            this.listenTo(model, {
                'model:reset sync': this.setHeaderSubtitle,
            });

            this.listenTo(view.content, { 'form:success': this.onFormSuccess });
        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.content, zone.$content)
                .assign(view.header, zone.$header);
        },

        resetModel: function() {
            var view = this.view.content;
            view.resetModel(this.model.attributes);
            view.setPristine();
        },

        setHeaderSubtitle: function() {
            var model = this.model;
            this.view.header.setSubtitle(model.isNew() ? 'New template' : model.get('name'));
        },

        changeUrl: function() {
            Backbone.history.navigate(Mustache.render(this.url, {
                groupId: this.group.id,
                templateId: this.model.id
            }));
        },

        ////////////
        // events //
        ////////////

        onResize: function(e) {
            var view = this.view.content;
            if (view.onResize) view.onResize(e);
        },

        onFormSuccess: function() {
            TemplateEvents.templateChange(this.model.clone());
            this.setHeaderSubtitle();
            this.changeUrl();
        },

    });

    return VTemplate;

});

